import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchAdjustmentRequestList = createAsyncThunk(
  "fetchAdjustmentRequestList",
  async ({ page, limit, filters }) => {
    const token = localStorage.getItem("auth_token");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    const keyword = filters?.keyword ? filters?.keyword : "";
    const requestType = filters?.requestType ? filters?.requestType : "";
    const status = filters?.status ? filters?.status : "";

    const response = await axiosHttp.get(
      `adjustment-request/list?page=${page}&limit=${limit}&keyword=${keyword}&requestType=${requestType}&status=${status}`,
      config
    );

    return response.data.data;
  }
);

const adjustmentRequestListSlice = createSlice({
  name: "adjustmentRequestList",
  initialState: {
    isLoading: false,
    data: {
      docs: [],
      currentPage: 1,
      total: 0,
    },
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(fetchAdjustmentRequestList.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchAdjustmentRequestList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = {
        docs: action.payload.docs || [],
        currentPage: action.payload.page || 1,
        total: action.payload.total || 0,
      };
    });

    builder.addCase(fetchAdjustmentRequestList.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default adjustmentRequestListSlice.reducer;
